import { Box, HStack, VStack } from '@chakra-ui/react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type CapitalFullProps = {
  children?: React.ReactNode;
};

export const CapitalFull: React.FC<CapitalFullProps> = () => {
  const { property } = usePropertiesModel();
  const totalPropertyAmount = Number(property?.target_amount ?? 0);

  let totalInvestors = Number(property?.investor_count?.total);
  if (isNaN(totalInvestors)) totalInvestors = 0;

  return (
    <VStack gap={5} alignItems={'flex-start'} justifyItems={'flex-start'} w="full">
      <HStack alignItems={'flex-end'}>
        <TextBlock fontSize={'40px'} weight="bold" lineHeight={1}>
          {currency.format(totalPropertyAmount ?? 0, { maximumFractionDigits: 0 })}
        </TextBlock>
        <TextBlock fontSize={'16px'} color="gray.600">
          RAISED
        </TextBlock>
      </HStack>

      <Box backgroundColor="gray.100" borderRadius={15} h={15} w={'full'}>
        <Box background={'gray.500'} borderRadius={15} h={15} w={`100%`}></Box>
      </Box>
      <HStack gap="32px">
        <HStack justifyItems={'flex-start'} alignItems={'flex-end'}>
          <TextBlock fontSize={'24px'} weight="bold" lineHeight={1}>
            {totalInvestors}
          </TextBlock>
          <TextBlock fontSize={'16px'} color="gray.600">
            {Number(totalInvestors) === 1 ? 'INVESTOR' : 'INVESTORS'}
          </TextBlock>
        </HStack>
        <HStack justifyItems={'flex-start'} alignItems={'flex-end'}>
          <TextBlock fontSize={'24px'} weight="bold" lineHeight={1}>
            {100}%
          </TextBlock>
          <TextBlock fontSize={'16px'} color="gray.600">
            {'RAISED'}
          </TextBlock>
        </HStack>
      </HStack>
      <Box
        background={`gray.300`}
        borderRadius={'5px'}
        color={'white'}
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontSize={'18px'}
        lineHeight={'60px'}
        textAlign={'center'}
        w={'full'}>
        Fully Funded
      </Box>
    </VStack>
  );
};
